import "./index.css";
import React, { useEffect, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import COD from "./templates/COD";
import Credit from "./templates/Credit";
import { setPaymentMode, afterOrderPlaced } from "../../store/order.store";
import Frame from "../../assets/Frame.svg";
import { fireGtagEvent } from "../../utils/google-analytics";
import { addNewScriptCashKoroThankYouPage } from "../../utils/cashkoro-analytics";
import { fireFbEvent } from "../../utils";

function PaymentComponent() {
  const dispatch = useDispatch();
  const { state } = useLocation();

  const { order, cart, config } = useSelector((each) => ({
    order: each.order,
    cart: each.cart,
    config: each.config
  }));

  const totalAmount = useMemo(() => {
    const cartDetails = cart?.cartDetails;
    if (
      cartDetails?.totalAmount > (config?.shipping_charge_max_threshold || 499)
    )
      return (cartDetails?.finalAmount || 0).toFixed(2);

    return (
      (cartDetails?.finalAmount || 0) + (config.shipping_charge_amount || 50)
    ).toFixed(2);
  }, [config, cart.cartDetails]);

  useEffect(() => {
    if (order.orderPlaced) {
      const timer = setTimeout(() => {
        dispatch(afterOrderPlaced());
      }, 5000);
      return () => clearTimeout(timer);
    }

    return () => {};
  }, [order.orderPlaced, dispatch]);

  const renderPaymentTemplate = useCallback(() => {
    switch (order.paymentMode) {
      case "cod":
        return <COD />;
      case "credit":
        return <Credit />;
      default:
        dispatch(setPaymentMode("credit"));
        return <Credit />;
    }
  }, [order.paymentMode]);

  const handleOnCompleted = useCallback(() => {
    dispatch(afterOrderPlaced());
  }, [dispatch]);

  useEffect(() => {
    fireGtagEvent("add_payment_info", {
      paymentMode: order.paymentMode,
      orderDetails: order.orderDetails
    });
    fireFbEvent("AddPaymentInfo", { orderDetails: order.orderDetails });
  }, [order]);

  useEffect(() => {
    if (order.orderPlaced) {
      fireGtagEvent("purchase", { orderDetails: order.orderDetails });
      fireFbEvent("Purchase", { orderDetails: order.orderDetails });
      addNewScriptCashKoroThankYouPage(order.orderDetails);
    }
  }, [order.orderPlaced]);

  const paymentBox = useMemo(
    () => (
      <div className="payment_box">
        <div className="payment_box_total">
          <h2>
            Total Payable Amount
            <strong>
              Rs.{" "}
              {(Math.floor(totalAmount * 100) / 100).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </strong>
          </h2>
        </div>
      </div>
    ),
    [order.orderDetails]
  );

  if (!state?.shippingAddressId) {
    return <Navigate to="/address" />;
  }

  if (order.orderPlaced) {
    return (
      <div className="final-page">
        <h2>Thank You</h2>
        <img src={Frame} alt="" />
        <h4>Thank you for your purchase!!</h4>
        <h5>
          You will receive an order confirmation notification with the full
          detail of your order shortly.
        </h5>
        <button
          type="button"
          className="continue-shopping pointer"
          onClick={handleOnCompleted}
        >
          Continue Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="payment-main">
      <div className="payment">
        <div className="payment-upper-section payment_new">
          {order.paymentMode !== "cod" && (
            <div className="payment_box">
              <h6>Please complete your payment on Razorpay</h6>
              {paymentBox}
            </div>
          )}
          {order.paymentMode === "cod" && paymentBox}
          {renderPaymentTemplate()}
        </div>
      </div>
    </div>
  );
}

export default PaymentComponent;
